import { Box, CircularProgress } from '@mui/material'
import {
  ModalActionButton,
  ModalActionButtonsContainer,
} from 'src/mentor/components/MentorAvailabilityPage/MentorAvailabilityPageStyles'

export default function FormActionButtons({ onCancel, onSave, saving, isValid, isEdit, isDisabled }) {
  return (
    <ModalActionButtonsContainer>
      <ModalActionButton onClick={onCancel}>Cancel</ModalActionButton>
      <ModalActionButton
        success={isValid || !saving}
        onClick={() => {
          if (isValid || !saving) {
            onSave()
          }
        }}
        disabled={isDisabled}
      >
        <Box sx={{ display: 'flex' }}>
          {saving ? (
            <CircularProgress size={24} sx={{ color: '#415dfc' }} />
          ) : (
            <>{isEdit ? 'Save' : 'Create'}</>
          )}
        </Box>
      </ModalActionButton>
    </ModalActionButtonsContainer>
  )
}
